export default __webpack_public_path__ + "fc06b3bf22ea5ff582797a6328f0fd44.png";